<template>
  <div>
    <!-- MULTIPLE FNB ITEMS MODAL -->
    <b-modal
      hide-footer
      hide-header
      hide-backdrop
      no-close-on-esc
      no-close-on-backdrop
      size="md"
      id="multi-fnb"
      ref="multi-fnb"
    >
      <div
        style="padding:1rem;border-bottom:1px solid #DEE2E6;font-size:20px;font-weight: bold;margin: 0 -15px"
      >Add multiple items</div>
      <div class="pt-3">
        <button
          class="btn-modal-close"
          style="top: 15px;
  right: 15px;
  position: absolute;
  z-index: 99;"
          @click="ClearData()"
        >&times;</button>
        <p class="text-center">
          Enter number of quantity for
          <br />
          <span class="font-weight-semi-bold">{{ ItemDetails.item_name }}</span> to be added.
        </p>
        <div class="pos-min-height-wrapper d-flex align-items-center">
          <div class="pos-mobile-number">
            <form>
              <div class="row">
                <!-- <span>{{ Increasedquantity && Increasedquantity.length > 0 ? '' : ''}}</span> -->
                <div class="col-12 mb-4">
                  <input
                    type="number"
                    autofocus
                    v-model="Increasedquantity"
                    @change="inputChange($event)"
                    placeholder="Quantity"
                  />
                </div>

                <div class="col-11 mx-auto">
                  <div class="row">
                    <div class="col-4 mb-2" v-for="(value , index) in phone_value" :key="index">
                      <button
                        v-if="index == phone_value.length-1"
                        @click.prevent.stop="onSliceNUmber()"
                        class="number"
                      >{{ value.name }}</button>
                      <button
                        v-else-if="value.name != ''"
                        @click.prevent.stop="onClickNumber(value.name)"
                        class="number"
                      >{{ value.name }}</button>
                      <button v-else @click.prevent.stop="clearInput" class="number">C</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="text-center mt-4">
          <button
            :disabled="Increasedquantity == null ? true : false"
            @click.prevent.stop="AddQuantityForItem()"
            class="btn-blue-lg px-4"
          >Add Items</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  props: {
    onClickHandler: {
      type: Function,
    },
  },
  data() {
    return {
      ItemDetails: {},
      Increasedquantity: null,
      phone_value: [
        { name: "1" },
        { name: "2" },
        { name: "3" },
        { name: "4" },
        { name: "5" },
        { name: "6" },
        { name: "7" },
        { name: "8" },
        { name: "9" },
        { name: "" },
        { name: "0" },
        { name: "<-" },
      ],
    };
  },
  watch: {
    "$store.getters.onAddItem": function (newVal, oldVal) {
      if (newVal && newVal.item_id) {
        console.log('onAddItem newVal', newVal)
        this.ItemDetails = newVal;
        this.$bvModal.show("multi-fnb");
      }
    },
  },
  computed: {
    ...mapGetters(["onAddItem"]),
  },
  methods: {
    onSliceNUmber: function () {
      this.Increasedquantity = this.Increasedquantity.slice(0, -1);
      if (this.Increasedquantity.length == 0) {
        this.Increasedquantity = null;
      }
    },
    ClearData: function () {
      this.Increasedquantity = null;
      this.$store.commit("CLEAR_ITEM_DETAILS");
      this.$bvModal.hide("multi-fnb");
    },
    clearInput: function () {
      this.Increasedquantity = "";
    },
    onClickNumber: function (num) {
      this.Increasedquantity
        ? (this.Increasedquantity += `${num}`)
        : (this.Increasedquantity = `${num}`);
    },
    AddQuantityForItem: function () {
      this.$store.dispatch("Add_More_Quantity_For_Item", {
        moreQuantity: this.Increasedquantity,
        ItemDetails: this.ItemDetails,
      });
      this.Increasedquantity = null;
      this.$bvModal.hide("multi-fnb");
    },
    inputChange(event) {},

    callClose: function () {
      this.onClickHandler({ name: "PosMultiFnB" });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/PosFnbContainer/posMultiFnB.vue